import { ContainerModuleLoader, withDependencies } from '@wix/thunderbolt-ioc'
import { getStore } from './stores'
import { CompRefs } from './compRefs'
import { CompEventsRegistrar } from './compEventsRegistrar'
import { CompsLifeCycle } from './compsLifeCycle'
import { StructureAPI } from './structureApi'
import {
	AppStructure,
	PropsMap,
	CompActions,
	IStructureStore,
	IPropsStore,
	Props,
	ICompActionsStore,
	CompActionsSym,
	IStructureAPI,
	StructureAPI as StructureAPISym,
	IRendererPropsExtender,
	RendererPropsExtenderSym,
	CompsLifeCycleSym,
	CompEventsRegistrarSym,
	ICompsLifeCycle,
	ICompEventsRegistrar,
	CompRefAPISym,
} from '@wix/thunderbolt-symbols'
import { Structure } from './symbols'

export { Structure }

const rendererPropsExtender = withDependencies(
	[StructureAPISym, Props, CompsLifeCycleSym, CompEventsRegistrarSym],
	(
		structureAPI: IStructureAPI,
		propsStore: IPropsStore,
		compsLifeCycle: ICompsLifeCycle,
		compEventsRegistrar: ICompEventsRegistrar
	): IRendererPropsExtender => {
		return {
			async extendRendererProps() {
				await structureAPI.addShellStructure()
				return {
					structure: structureAPI,
					props: propsStore,
					compsLifeCycle,
					compEventsRegistrar,
				}
			},
		}
	}
)

export const site: ContainerModuleLoader = (bind) => {
	const structure = getStore<AppStructure>()
	const props = getStore<PropsMap>()
	const compActions = getStore<CompActions>()

	// Serializable
	bind<IStructureStore>(Structure).toConstantValue(structure)
	bind<IPropsStore>(Props).toConstantValue(props)
	// Not Serializable
	bind<ICompActionsStore>(CompActionsSym).toConstantValue(compActions)

	bind<IStructureAPI>(StructureAPISym).to(StructureAPI)
	bind<IStructureAPI>(CompRefAPISym).to(CompRefs)
	bind(CompEventsRegistrarSym).to(CompEventsRegistrar)
	bind(CompsLifeCycleSym).to(CompsLifeCycle)
	bind<IRendererPropsExtender>(RendererPropsExtenderSym).to(rendererPropsExtender)
}
